/*
 * 积分商城管理端 API
 * 路径对齐 points_mall/urls.py，响应格式对齐 administration：
 * { code, msg, data: [...], total, page, page_size }
 */
import request from '@/utils/request'
import base from './base'

export const host = base.api_data

export default {
  baseurl: host,

  // ---------- 积分账户 ----------
  api_account_search(params = {}) {
    return request.post(`${host}/points_mall/account/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 手动加减分
  api_account_adjust(params = {}) {
    return request.post(`${host}/points_mall/account/adjust/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 导出积分账户（blob）
  api_account_export(params = {}) {
    return request.get(`${host}/points_mall/account/export/`, {
      params,
      responseType: 'blob',
      timeout: 60000
    })
  },

  // 批量导入加减分上传地址（供 ImportDialog / el-upload）
  api_account_import: '/points_mall/account/import/',

  // 导入模板下载地址
  api_account_import_template: '/points_mall/account/import/template/',

  // ---------- 积分流水 ----------
  api_record_search(params = {}) {
    return request.post(`${host}/points_mall/record/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // ---------- 商品 ----------
  api_product_search(params = {}) {
    return request.post(`${host}/points_mall/product/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_product_save(params = {}) {
    return request.post(`${host}/points_mall/product/save/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_product_action(params = {}, method = 'delete') {
    if (method === 'DELETE' || method === 'delete') {
      return request.delete(`${host}/points_mall/product/action/`, { data: params })
    }
    return request.post(`${host}/points_mall/product/action/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_product_shelf(params = {}) {
    return request.post(`${host}/points_mall/product/shelf/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 商品封面图上传地址（供 el-upload action 使用）
  api_product_upload_image: '/points_mall/product/uploadImage/',

  // ---------- 兑换订单 ----------
  api_order_search(params = {}) {
    return request.post(`${host}/points_mall/order/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_order_approve(params = {}) {
    return request.post(`${host}/points_mall/order/approve/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 导出兑换订单（blob，按筛选条件）
  api_order_export(params = {}) {
    return request.get(`${host}/points_mall/order/export/`, {
      params,
      responseType: 'blob',
      timeout: 60000
    })
  },

  // ---------- 感动故事 ----------
  api_story_search(params = {}) {
    return request.post(`${host}/points_mall/story/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_story_save(params = {}) {
    return request.post(`${host}/points_mall/story/save/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_story_shelf(params = {}) {
    return request.post(`${host}/points_mall/story/shelf/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：故事点赞
  api_story_like(params = {}) {
    return request.post(`${host}/points_mall/story/like/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：故事评论列表
  api_story_comments(params = {}) {
    return request.get(`${host}/points_mall/story/comments/`, { params })
  },

  // 员工端：发表故事评论（可含 images 配图路径）
  api_story_comment_create(params = {}) {
    return request.post(`${host}/points_mall/story/comment/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：撤回自己的感动故事评论
  api_story_comment_withdraw(params = {}) {
    return request.post(`${host}/points_mall/story/comment/withdraw/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 管理端：故事评论查询
  api_story_comments_search(params = {}) {
    return request.post(`${host}/points_mall/story/comments/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 管理端：删除故事评论
  api_story_comment_delete(params = {}) {
    return request.post(`${host}/points_mall/story/comment/delete/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：评论配图上传（三类评论共用；FormData 字段 cover_image）
  api_comment_upload_image(file) {
    const fd = new FormData()
    fd.append('cover_image', file)
    return request.post(`${host}/points_mall/comment/uploadImage/`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000
    })
  },

  // 感动故事图片上传地址（供 el-upload action 使用）
  api_story_upload_image: '/points_mall/story/uploadImage/',

  // ---------- 顾客心声（人工录入 · 红黑榜） ----------
  api_customer_voice_search(params = {}) {
    return request.post(`${host}/points_mall/customer_voice/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_voice_save(params = {}) {
    return request.post(`${host}/points_mall/customer_voice/save/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_voice_shelf(params = {}) {
    return request.post(`${host}/points_mall/customer_voice/shelf/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 顾客心声配图上传地址
  api_customer_voice_upload_image: '/points_mall/customer_voice/uploadImage/',

  // 员工端：顾客心声点赞
  api_customer_voice_like(params = {}) {
    return request.post(`${host}/points_mall/customer_voice/like/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：顾客心声看板（上架 · 含红榜/黑榜）
  api_employee_customer_voices() {
    return request.get(`${host}/points_mall/customer_voices/board/`)
  },

  // 员工端：顾客心声详情
  api_employee_customer_voice_detail(params = {}) {
    return request.get(`${host}/points_mall/customer_voices/detail/`, { params })
  },

  // ---------- 顾客感动故事 ----------
  api_customer_story_search(params = {}) {
    return request.post(`${host}/points_mall/customer_story/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_story_save(params = {}) {
    return request.post(`${host}/points_mall/customer_story/save/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_story_shelf(params = {}) {
    return request.post(`${host}/points_mall/customer_story/shelf/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_story_like(params = {}) {
    return request.post(`${host}/points_mall/customer_story/like/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_story_comments(params = {}) {
    return request.get(`${host}/points_mall/customer_story/comments/`, { params })
  },

  api_customer_story_comment_create(params = {}) {
    return request.post(`${host}/points_mall/customer_story/comment/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：撤回自己的顾客感动评论
  api_customer_story_comment_withdraw(params = {}) {
    return request.post(`${host}/points_mall/customer_story/comment/withdraw/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_story_comments_search(params = {}) {
    return request.post(`${host}/points_mall/customer_story/comments/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_story_comment_delete(params = {}) {
    return request.post(`${host}/points_mall/customer_story/comment/delete/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_customer_story_upload_image: '/points_mall/customer_story/uploadImage/',

  api_customer_story_backfill_cover(params = {}) {
    return request.post(`${host}/points_mall/admin/customer_story/backfill_cover/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：顾客感动故事看板
  api_employee_customer_stories() {
    return request.get(`${host}/points_mall/customer_stories/board/`)
  },

  // 员工端：顾客感动故事详情
  api_employee_customer_story_detail(params = {}) {
    return request.get(`${host}/points_mall/customer_stories/detail/`, { params })
  },

  // 微信/朋友圈：感动故事对外只读（免登录）
  api_share_story_public(params = {}) {
    return request.get(`${host}/points_mall/share/story/`, { params })
  },

  // 微信/朋友圈：顾客感动对外只读（免登录）
  api_share_customer_story_public(params = {}) {
    return request.get(`${host}/points_mall/share/customer_story/`, { params })
  },

  // ---------- 改善创新（企微初审+5入库待二审；二审/人工优秀案例+25） ----------
  api_improve_search(params = {}) {
    return request.post(`${host}/points_mall/improve/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_improve_save(params = {}) {
    return request.post(`${host}/points_mall/improve/save/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_improve_shelf(params = {}) {
    return request.post(`${host}/points_mall/improve/shelf/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 改善创新配图上传地址
  api_improve_upload_image: '/points_mall/improve/uploadImage/',

  // 导出改善创新（blob，仅需登录）
  api_improve_export(params = {}) {
    return request.get(`${host}/points_mall/improve/export/`, {
      params,
      responseType: 'blob',
      timeout: 60000
    })
  },

  // 提案类型 → 二审人配置
  api_improve_type_reviewer_search(params = {}) {
    return request.post(`${host}/points_mall/improve/type_reviewer/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },
  api_improve_type_reviewer_save(params = {}) {
    return request.post(`${host}/points_mall/improve/type_reviewer/save/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },
  api_improve_type_reviewer_delete(params = {}) {
    return request.post(`${host}/points_mall/improve/type_reviewer/delete/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：二审通过/驳回
  api_improve_l2_review(params = {}) {
    return request.post(`${host}/points_mall/improve/l2_review/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：改善创新看板
  api_employee_improves() {
    return request.get(`${host}/points_mall/improves/board/`)
  },

  // 员工端：我的相关故事/改善创新（主人公/提报人/改善人/待二审）
  api_employee_my_related(params = {}) {
    return request.get(`${host}/points_mall/my/related/`, { params })
  },

  // 员工端：故事详情（分享落地）
  api_employee_story_detail(params = {}) {
    return request.get(`${host}/points_mall/stories/detail/`, { params })
  },

  // 员工端：改善创新详情（分享落地）
  api_employee_improve_detail(params = {}) {
    return request.get(`${host}/points_mall/improves/detail/`, { params })
  },

  // 员工端：改善创新点赞
  api_improve_like(params = {}) {
    return request.post(`${host}/points_mall/improve/like/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：改善创新评论列表
  api_improve_comments(params = {}) {
    return request.get(`${host}/points_mall/improve/comments/`, { params })
  },

  // 员工端：发表改善创新评论（可含 images 配图路径）
  api_improve_comment_create(params = {}) {
    return request.post(`${host}/points_mall/improve/comment/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：撤回自己的改善创新评论
  api_improve_comment_withdraw(params = {}) {
    return request.post(`${host}/points_mall/improve/comment/withdraw/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 管理端：改善创新评论查询
  api_improve_comments_search(params = {}) {
    return request.post(`${host}/points_mall/improve/comments/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 管理端：删除改善创新评论
  api_improve_comment_delete(params = {}) {
    return request.post(`${host}/points_mall/improve/comment/delete/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：企微 JS-SDK 签名
  api_employee_jssdk_signature(params = {}) {
    return request.post(`${host}/points_mall/jssdk/signature/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：主题资源（积分卡背景等，公开接口，换主题只换服务器图片）
  api_employee_theme() {
    return request.get(`${host}/points_mall/theme/`)
  },

  // ---------- 失效提醒 ----------
  api_expire_search(params = {}) {
    return request.post(`${host}/points_mall/expire/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // ---------- 企微审批任务 ----------
  // 查看配置是否就绪（secret / 模板ID）
  api_approval_config() {
    return request.get(`${host}/points_mall/admin/approval/config/`)
  },

  // 手动按模块拉取企微审批（body.kind: moving_story|customer_story|improve）
  api_approval_sync(params = {}) {
    return request.post(`${host}/points_mall/admin/jobs/approval/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' },
      timeout: 180000
    })
  },

  // 员工端：查看审批配置
  api_employee_approval_config() {
    return request.get(`${host}/points_mall/my/approval/config/`)
  },

  // 员工端：按模块拉取企微审批（body.kind 同上）
  api_employee_approval_sync(params = {}) {
    return request.post(`${host}/points_mall/my/approval/sync/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' },
      timeout: 180000
    })
  },

  // 预览模板控件标题，用于核对 STORY_FIELD_* 配置
  api_approval_preview(params = {}) {
    return request.post(`${host}/points_mall/admin/approval/preview/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 无封面故事：按审批单补拉主人公照片（不发分）
  api_story_backfill_cover(params = {}) {
    return request.post(`${host}/points_mall/admin/story/backfill_cover/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // ---------- 员工端一键登录 / 业务 ----------
  api_employee_oauth_url(params = {}) {
    // 短超时：避免 Redis/网络异常时员工端一直停在「跳转中…」
    return request.get(`${host}/points_mall/auth/wecom/url/`, { params, timeout: 8000 })
  },

  api_employee_oauth_login(params = {}) {
    return request.post(`${host}/points_mall/auth/wecom/login/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_employee_dev_status() {
    return request.get(`${host}/points_mall/auth/dev/status/`)
  },

  api_employee_dev_search(params = {}) {
    return request.post(`${host}/points_mall/auth/dev/search/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_employee_dev_login(params = {}) {
    return request.post(`${host}/points_mall/auth/dev/login/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 管理账号（已绑定 openid）换取员工 token 进入商城
  api_employee_admin_enter(params = {}) {
    return request.post(`${host}/points_mall/auth/admin/enter/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  api_employee_me() {
    return request.get(`${host}/points_mall/auth/me/`)
  },

  api_my_account() {
    return request.get(`${host}/points_mall/my/account/`)
  },

  api_my_records(params = {}) {
    return request.get(`${host}/points_mall/my/records/`, { params })
  },

  api_my_orders(params = {}) {
    return request.get(`${host}/points_mall/my/orders/`, { params })
  },

  api_employee_products(params = {}) {
    return request.get(`${host}/points_mall/products/`, { params })
  },

  api_employee_exchange(params = {}) {
    return request.post(`${host}/points_mall/exchange/`, JSON.stringify(params), {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  // 员工端：积分到期提醒
  api_employee_expire_remind(params = {}) {
    return request.get(`${host}/points_mall/my/expire/remind/`, { params })
  },

  api_employee_stories() {
    return request.get(`${host}/points_mall/stories/board/`)
  }
}
